import React from 'react';

//import * as Scroll from 'react-scroll';
//import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';

import { Link } from 'react-scroll';

export default class ImgNavigator extends React.Component {
  constructor(props) {
    super(props);
    //props: imgcallback, imgurls, imgrefs
    this.state = {Imgs: undefined};
    let cnt=0;
    let ImgElems = props.imgurls.map((iurl) =>
    <Link to={"scrollref"+cnt} key={cnt++} smooth={true} duration={1000}>
      <div>
        <img className="growOnHover"
              src={iurl}
              width='50px'
              cursor="hand"
              alt=""
          />
      </div>
    </Link>
    );
    //this.setState({Imgs: ImgElems});
    this.state.Imgs = ImgElems;
  }

  render() {

    if(this.state.Imgs && this.props.imgurls.length > this.state.Imgs.length)
    {
      let newElem = <Link to={"scrollref"+(this.props.imgurls.length-1)} key={(this.props.imgurls.length-1)} smooth={true} duration={1000}>
        <div>
          <img className="growOnHover"
                src={this.props.imgurls[this.props.imgurls.length-1]}
                width='50px'
                cursor="hand"
                alt=""
            />
        </div>
      </Link>

      let tmpImgs = this.state.Imgs;
      tmpImgs.push(newElem);
      this.state.Imgs = tmpImgs;//nem szep

    }

    return (
      <div style={{position: 'fixed', right:'0px',top:'0px',cursor:'pointer'}}>
        {this.state.Imgs &&
          <div style={{userSelect: 'none', padding: '30px'}}>
            {this.state.Imgs}
          </div>
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/Component/ImgNavigator.js